export const testCollectionGroups = [
	{
		title: "CCNA 1",
		tests: [
			{
				title: 'CCNA1 | Modules 1 - 3: Basic Network Connectivity and Communications Exam Answers',
				questions: require('./ccna1/module1-3.json'),
			},
			{
				title: 'CCNA1 | Modules 4 - 7: Ethernet Concepts Exam Answers',
				questions: require('./ccna1/module4-7.json'),
			},
			{
				title: 'CCNA1 | Modules 8 - 10: Communicating Between Networks Exam Answers',
				questions: require('./ccna1/module8-10.json'),
			},
			{
				title: 'CCNA1 | Modules 11 - 13: IP Addressing Exam Answers',
				questions: require('./ccna1/module11-13.json'),
			},
			{
				title: 'CCNA1 | Modules 14 - 15: Network Application Communications Exam Answers',
				questions: require('./ccna1/module14-15.json'),
			},
			{
				title: 'CCNA1 | Modules 16 - 17: Building and Securing a Small Network Exam Answers',
				questions: require('./ccna1/module16-17.json'),
			},
		],
	},

	{
		title: "CCNA 2",
		tests: [
			{
				title: 'CCNA2 | Modules 1 - 4: Switching Concepts, VLANs, and InterVLAN Routing Exam Answers',
				questions: require('./ccna2/module1-4.json'),
			},
			{
				title: 'CCNA2 | Modules 5 - 6: Redundant Networks Exam Answers',
				questions: require('./ccna2/module5-6.json'),
			},
			{
				title: 'CCNA2 | Modules 7 - 9: Available and Reliable Networks Exam Answers',
				questions: require('./ccna2/module7-9.json'),
			},
			{
				title: 'CCNA2 | Modules 10 - 13: L2 Security and WLANs Exam Answers',
				questions: require('./ccna2/module10-13.json'),
			},
			{
				title: 'CCNA2 | Modules 14 - 16: Routing Concepts and Configuration Exam Answers',
				questions: require('./ccna2/module14-16.json'),
			},
			{
				title: 'CCNA2 | Final Exam',
				questions: require('./ccna2/final-exam.json'),
			},
		],
	},

	{
		title: "CCNA 3",
		tests: [
			{
				title: 'CCNA3 | Modules 1 - 2: OSPF Concepts and Configuration Exam Answers',
				questions: require('./ccna3/module1-2.json'),
			},
			{
				title: 'CCNA3 | Modules 3 - 5: Network Security Exam Answers',
				questions: require('./ccna3/module3-5.json'),
			},
			{
				title: 'CCNA3 | Modules 6 - 8: WAN Concepts Exam Answers',
				questions: require('./ccna3/module6-8.json'),
			},
			{
				title: 'CCNA3 | Modules 9 - 12: Optimize, Monitor, and Troubleshoot Networks Exam Answers',
				questions: require('./ccna3/module9-12.json'),
			},
			{
				title: 'CCNA3 | Modules 13 - 14: Emerging Network Technologies Exam Answers',
				questions: require('./ccna3/module13-14.json'),
			},
			{
				title: 'CCNA3 | Final Exam',
				questions: require('./ccna3/final-exam.json'),
			},
		],
	},
];
